import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from './FormManager';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  const { openGeneralForm } = useForm();
  const heroRef = useRef(null);
  const headlineRef = useRef(null);
  const subheadlineRef = useRef(null);
  const ctaRef = useRef(null);
  const clientBadgeRef = useRef(null);
  const noteRef = useRef(null);
  const guaranteeRef = useRef(null);
  
  // Animation on mount
  useEffect(() => {
    const hero = heroRef.current;
    const headline = headlineRef.current;
    const subheadline = subheadlineRef.current;
    const cta = ctaRef.current;
    const clientBadge = clientBadgeRef.current;
    const note = noteRef.current;
    const guarantee = guaranteeRef.current;

    if (hero && headline && subheadline && cta && clientBadge && note) {
      hero.classList.add('visible');
      
      // Staggered animations (much faster)
      setTimeout(() => headline.classList.add('visible'), 50);
      setTimeout(() => subheadline.classList.add('visible'), 100);
      setTimeout(() => cta.classList.add('visible'), 150);
      setTimeout(() => clientBadge.classList.add('visible'), 125);
      setTimeout(() => note.classList.add('visible'), 200);
      setTimeout(() => guarantee.classList.add('visible'), 250);
    }
  }, []);

  return (
    <section className="hero-section" ref={heroRef}>
      <div className="hero-background">
        <div className="hero-shape hero-shape-1"></div>
        <div className="hero-shape hero-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="client-badge" ref={clientBadgeRef}>
            <div className="client-badge-inner">
              <span className="client-badge-number">70+</span>
              <span className="client-badge-text">{t('clientBadgeText')}</span>
            </div>
          </div>
          
          <h1 
            className="hero-headline" 
            ref={headlineRef}
            dangerouslySetInnerHTML={{ __html: t('heroHeadline') }}
          />
          
          <p className="hero-subheadline" ref={subheadlineRef}>
            {t('heroSubheadline')}
          </p>
          
          <div className="hero-cta-container" ref={ctaRef}>
            <button className="hero-cta" onClick={openGeneralForm}>
              <span className="cta-text">{t('heroCta')}</span>
              <span className="cta-arrow">→</span>
            </button>
            <div className="hero-guarantee" ref={guaranteeRef}>
              <span className="guarantee-icon">✓</span>
              <span className="guarantee-text">{t('guaranteeText')}</span>
            </div>
            <div className="hero-note" ref={noteRef}>
              <span className="hero-note-icon">🇺🇸🇩🇪</span>
              <span className="hero-note-text">{t('noteText')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
